const transformFirefoxExtensionId = (url) => {
    if (!url?.match(/^https?:\/\//))
        return url;
    if (url?.includes('addons.mozilla.org')) {
        try {
            const urlObject = new URL(url);
            return urlObject.pathname.replace(/\/$/, '').split('/').at(-1);
        }
        catch {
            // ignore
        }
    }
    return;
};

export { transformFirefoxExtensionId };
